//CRN_20250502 - Ideal for NgbModals, useless for DevExtreme-Datagrid
//CRN_20250502 - For DevExtreme-Datagrid use PageCompMenuPrimeNgComponent

import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ExceptionsService } from '../../services/utelize/general/exceptions-service';

@Component({
  selector: 'app-page-comp-menu-bootstrap',
  templateUrl: './page-comp-menu-bootstrap.component.html',
  styleUrls: ['./page-comp-menu-bootstrap.component.scss']
})

export class PageCompMenuBootstrapComponent implements OnInit {

  @Input() menuItems: { label: string, command?: () => void }[]=[];

  @Output() itemSelected=new EventEmitter<string>();

  public left   : number =0;
  public top    : number =0;
  public visible: boolean=false;

  constructor(
    private elementRef       : ElementRef,
    private exceptionsService: ExceptionsService
  ) {
    
  }

  public ngOnInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public show(x: number, y: number) {
    try {
      this.left   =x;
      this.top    =y;
      this.visible=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public hide() {
    try {
      this.visible=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public selectItem(item: { label: string, command?: () => void }) {
    try {
      if (item.command) {
        item.command();
      }

      this.itemSelected.emit(item.label);
      this.hide();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  @HostListener("document:click", ["$event"])
  private onDocumentClick(event: MouseEvent) {
    try {
      const clickedInside=(this.elementRef.nativeElement as HTMLElement).contains(event.target as Node);

      if (!clickedInside && this.visible) {
        this.hide();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
